import { SIGNIN, FORGOT_PASSWORD, RESET_PASSWORD, LOGOUT, UPDATE_ADMIN_PROFILE, GET_DETAIL_ADMIN_PROFILE, CHANGE_PASSWORD,UPDATE_IMAGE_PROFILE, RESEND_OTP } from "../../Constants/AuthConstants";
import { createGetDataReducer } from "./CommonReducer";

export const AdminLogInReducer = createGetDataReducer( SIGNIN );
export const ForgotPasswordReducer = createGetDataReducer( FORGOT_PASSWORD );
export const ResetPasswordReducer = createGetDataReducer( RESET_PASSWORD );
export const LogoutReducer = createGetDataReducer( LOGOUT );
export const UpdateAdminProfileReducer = createGetDataReducer( UPDATE_ADMIN_PROFILE );
export const DetailAdminProfileReducer = createGetDataReducer( GET_DETAIL_ADMIN_PROFILE );
export const AdminChangePasswordReducer = createGetDataReducer( CHANGE_PASSWORD );
export const AdminUpdateProfileReducer = createGetDataReducer( UPDATE_IMAGE_PROFILE );
export const AdminResendOtpReducer = createGetDataReducer( RESEND_OTP );


